import { shallowEqual } from "react-redux";
import { useParams } from "react-router-dom";
import { TournamentLoader } from "pages/TournamentLoader";
import { selectTournamentIdsFromTrackId, selectTrack } from "selectors/Track";
import { TrackPageContent } from "./TrackPageContent";
import { ErrorMessagePage } from "pages/PageTemplates";
import { TrackLoader } from "pages/TrackLoader";
import { useAppSelector } from "app/hooks";

export const TrackPage = () => {
  const { id } = useParams();
  const tournamentIds = useAppSelector(
    (state) => (!!id ? selectTournamentIdsFromTrackId(state, id) : []),
    shallowEqual
  );

  const track = useAppSelector((state) => selectTrack(state, id));
  return (
    <TournamentLoader tournamentIds={tournamentIds}>
      <TrackLoader tournamentIds={tournamentIds}>
        {!!track ? (
          <TrackPageContent track={track} />
        ) : (
          <ErrorMessagePage message="Track Could Not Be Found" />
        )}
      </TrackLoader>
    </TournamentLoader>
  );
};
